interface Props {
  color?: string
  width?: number
  height?: number
}

export const LayersIcon = ({ color = '#6F6F6F', width = 21, height = 20 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.335 15.5284C20.5956 15.4373 20.8804 15.5745 20.9717 15.8351C21.0629 16.0957 20.9257 16.3806 20.665 16.4718L10.665 19.9718C10.5581 20.0092 10.4419 20.0092 10.335 19.9718L0.334961 16.4718C0.074353 16.3806 -0.0628699 16.0957 0.0283203 15.8351C0.11956 15.5745 0.40444 15.4373 0.665039 15.5284L10.5 18.9698L20.335 15.5284ZM20.335 11.5284C20.5956 11.4373 20.8804 11.5745 20.9717 11.8351C21.0629 12.0957 20.9257 12.3806 20.665 12.4718L10.665 15.9718C10.5581 16.0092 10.4419 16.0092 10.335 15.9718L0.334961 12.4718C0.0743532 12.3806 -0.0628699 12.0957 0.0283203 11.8351C0.11956 11.5745 0.40444 11.4373 0.665039 11.5284L10.5 14.9698L20.335 11.5284ZM20.335 7.52844C20.5956 7.43727 20.8804 7.57451 20.9717 7.83508C21.0629 8.0957 20.9257 8.38058 20.665 8.4718L10.665 11.9718C10.5581 12.0092 10.4419 12.0092 10.335 11.9718L0.334961 8.4718C0.0743532 8.38057 -0.0628699 8.0957 0.0283203 7.83508C0.11956 7.57451 0.40444 7.43727 0.665039 7.52844L10.5 10.9698L20.335 7.52844ZM10.417 0.00695801C10.499 -0.00684231 10.5837 6.39761e-05 10.6631 0.0274658L20.6631 3.4845C20.8638 3.55389 20.9991 3.74283 21 3.9552C21.0008 4.16766 20.8673 4.35787 20.667 4.42883L10.667 7.9718C10.559 8.01003 10.441 8.01003 10.333 7.9718L0.333008 4.42883C0.132747 4.35787 -0.000811048 4.16766 0 3.9552C0.000910395 3.74283 0.136177 3.55389 0.336914 3.4845L10.3369 0.0274658L10.417 0.00695801ZM2.0127 3.96301L10.5 6.96887L18.9863 3.96301L10.5 1.02844L2.0127 3.96301Z"
        fill={color}
      />
    </svg>
  )
}
